export const isDev = () => window.location.hostname.includes('localhost');
export const isStaging = () => window.location.hostname.includes('staging');
export const isProduction = () => !isDev() && !isStaging();
export const launchDarkly = {
  clientSideId: isDev()
    ? '6301ec6419c4f8119d710bc1'
    : isStaging()
    ? '62e1fd72edce7b10f37ff150'
    : '62e1fd5358fc91111c6c2b40',
};

export const SC_BASE_URI = userId => {
  return isDev()
    ? `https://localhost:3000/users/${userId}/student-center/`
    : isStaging()
    ? `https://staging.app.crimsoneducation.org/users/${userId}/student-center/`
    : `https://app.crimsoneducation.org/users/${userId}/student-center/`;
};

export const SC_API_URI = isDev()
  ? 'http://localhost:3010/graphql'
  : isStaging()
  ? 'https://api.staging.core-student-center.crimsoneducation.org/graphql'
  : 'https://api.core-student-center.crimsoneducation.org/graphql';
export const CRIMSON_APP_API_URI = isDev()
  ? 'http://localhost:3005/graphql'
  : isStaging()
  ? 'https://api.staging.app.crimsoneducation.io/graphql'
  : 'https://api.app.crimsoneducation.io/graphql';
